import { NgModule } from '@angular/core';

import { EventStatusPipe } from './event.status.pipe';

@NgModule({
  declarations: [
    EventStatusPipe
  ],
  providers: [
    EventStatusPipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'eventStatus',
      useClass: EventStatusPipe
    }
  ]
})
export class EventsModule {}